//记得在 src\components\lang\zhLoad.js 里面添加对象
const manualWeigh = {
};
export default manualWeigh



// WEBPACK FOOTER //
// ./src/page/bd/manualWeigh/lang/manualWeigh.zh.js